export const baseEndpoint = '/v1/files';

export const fileConfigs = {
    uploadFile: {
        method: 'POST',
        endpoint: `${baseEndpoint}`
    },
    downloadFile: {
        method: 'GET',
        endpoint: `${baseEndpoint}/`
    }
}